import React, { useMemo } from 'react'
import { QueryBuilder } from '@mui/icons-material'

import { Container, HeadItem, TopLine, Name, Count, Meta } from './styles'
import { useSchedule } from '../../../hooks/ScheduleContext'
import { useEmployee } from '../../../store/schedule/useEmployee'

/** Os turnos vem da API em segundos a partir da meia-noite. */
function paraHora(segundos) {
  if (segundos === null || segundos === undefined) return ''

  const total = Math.floor(Number(segundos) / 60)
  const hora = String(Math.floor(total / 60)).padStart(2, '0')
  const minuto = String(total % 60).padStart(2, '0')

  return `${hora}:${minuto}`
}

/** "08:00–17:00", ou os dois turnos quando o profissional faz intervalo. */
function horarioDeAtendimento(shifts) {
  if (!Array.isArray(shifts) || !shifts.length) return ''

  return shifts
    .map((turno) => `${paraHora(turno.startsAt)}–${paraHora(turno.finishesAt)}`)
    .join(' · ')
}

export function Head() {
  const { getEmployees, getSchedules } = useSchedule()
  const {
    employee: { size },
  } = useEmployee()

  const employees = getEmployees()
  const schedules = getSchedules()

  // quantos agendamentos cada profissional tem no dia que esta na tela
  const totalPorProfissional = useMemo(() => {
    const lista = Array.isArray(schedules) ? schedules : []

    return lista.reduce((contagem, agendamento) => {
      const id = agendamento?.employeeId || agendamento?.roomId
      if (!id) return contagem

      contagem[id] = (contagem[id] || 0) + 1
      return contagem
    }, {})
  }, [schedules])

  return (
    <Container totalEmployees={employees.length} collumnSize={size}>
      <HeadItem>
        <QueryBuilder />
      </HeadItem>

      {!!employees &&
        employees.map((employee) => {
          const horario = horarioDeAtendimento(employee.shifts)
          // nas lojas em que a funcao nao esta cadastrada, ela costuma vir
          // dentro do proprio nome; ai mostramos so o horario
          const detalhe = [employee.jobTitle, horario].filter(Boolean).join(' · ')

          return (
            <HeadItem key={employee.id} title={employee.name}>
              <TopLine>
                <Name>{employee.name}</Name>
                <Count title="Agendamentos no dia">
                  {totalPorProfissional[employee.id] || 0}
                </Count>
              </TopLine>
              {!!detalhe && <Meta>{detalhe}</Meta>}
            </HeadItem>
          )
        })}
    </Container>
  )
}
